import React, { useEffect, useState } from 'react';
import { Link } from 'react-scroll';
import * as c from '../../ts/const';
import ImgPictures from '../components/img-pictures';
const GotoBanner = () => {
    const [className, setClassName] = useState('goto-banner sm:gutter');
    useEffect(() => {
        const saleBlockEl = document.getElementById('js-sale-group');
        const vh = window.innerHeight;
        if (saleBlockEl) {
            let observer = new IntersectionObserver((entries, observer) => {
                for (let entry of entries) {
                    // 要素が見えている場合
                    if (entry.isIntersecting) {
                        setClassName('goto-banner sm:gutter goto-banner--leave');
                    }
                    else {
                        setClassName('goto-banner sm:gutter goto-banner--enter');
                    }
                }
            }, {
                rootMargin: `${vh / 2}px 0px -${vh}px 0px`
            });
            observer.observe(saleBlockEl);
        }
    }, []);
    return (React.createElement("div", { className: className },
        React.createElement(Link, { to: 'lottery-box', smooth: true, duration: 300, id: 'TOP_fukubiki', className: 'cursor-pointer' },
            React.createElement(ImgPictures, { fileNameLarge: `./assets/img/banner/goto-beginner-desk-md`, fileNameSmall: `./assets/img/banner/goto-beginner-desk-sm`, mediaQueryLarge: c.MEDIA_QUERY_LARGE, mediaQuerySmall: c.MEDIA_QUERY_SMALL, alt: '\u30B2\u30FC\u30E0\u6848\u5185\u6240\u306F\u3053\u3061\u3089' }))));
};
export default GotoBanner;
